import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@packages/ui';
import { Arrow, ArrowProps } from '../Arrow/Arrow';

const ArrowRightStyled = styled(Arrow)<{ elevation: number | number[] }>`
  border-radius: 28px 0 0 28px;
  padding-left: 7px;
`;

export const ArrowRight: React.FC<ArrowProps> = ({ onClick, className }) => {
  return (
    <ArrowRightStyled onClick={onClick as any} elevation={2} className={className}>
      <Icon size={16} name="chevronRight" />
    </ArrowRightStyled>
  );
};
